module.exports = __webpack_public_path__ + "static/scientist5-ddaf0350c4d5d7e39c5186e4d1551039.png";